import { render, staticRenderFns } from "./StudyHomepage.vue?vue&type=template&id=48ce19c2&"
import script from "./studyHomePage03.js?vue&type=script&lang=js&"
export * from "./studyHomePage03.js?vue&type=script&lang=js&"
import style0 from "./StudyHomepage.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports